import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';
import { siteConfig } from '../data/siteData';

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);

  // Clean phone number — remove spaces, dashes, + sign for wa.me link
  const phone = siteConfig.phone.replace(/[\s\-\+]/g, '');

  const message = encodeURIComponent(
    'Hello! I am interested in your construction services. Could you please provide more information?'
  );

  const whatsappUrl = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-fab ${hovered ? 'whatsapp-fab-hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Chat on WhatsApp"
    >
      {/* Tooltip */}
      <span className={`whatsapp-tooltip ${hovered ? 'whatsapp-tooltip-visible' : ''}`}>
        Chat with us!
      </span>

      {/* Pulse rings */}
      <span className="whatsapp-pulse" />
      <span className="whatsapp-pulse whatsapp-pulse-2" />

      {/* Icon */}
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppButton;